import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ConfigService } from './auth/config.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient, private configService: ConfigService, private router: Router) { }
  getUserList(data:any) {
    const apiUrl = `${this.configService.getApiUrl()}/User/GetUserList`;   
    return this.http.post<any>(apiUrl,data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('User List request failed.'));
      })
    );
    
  }
    getLoginUser()
  {
    const apiUrl = `${this.configService.getApiUrl()}/User/GetLoginUser`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Please try again!'));
      })
    );
  }
  updateUserProfile(data:any)
  {
    const apiUrl = `${this.configService.getApiUrl()}/User/updateUserProfile`;
    return this.http.post<any>(apiUrl,data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Sorry! Not Update Information.'));
      })
    );
  }

  
// Added By Ranjit 18/9/2026
getDecryptedUserPassword(data: any) {

  const apiUrl =
    `${this.configService.getApiUrl()}/User/GetDecryptUserPassword`;

  return this.http.post<any>(apiUrl, data).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(
        () => new Error('Sorry! Unable to retrieve password.')
      );
    })
  );
}




}
